import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-post-share',
  templateUrl: './post-share.component.html',
  styleUrls: ['./post-share.component.scss']
})
export class PostShareComponent implements OnInit, AfterViewInit {
  @Input() link = window.location.href;
  @Input() subject;
  @Input() caption;
  email: string;
  $html;
  $body;

  constructor() { }

  fbShare() {
    const fbUrl = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(this.link);
    this.popup(fbUrl, 570, 520);
  }

  twitterShare() {
    const twUrl = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.subject) + '&url=' +
      encodeURIComponent(this.link);
    this.popup(twUrl, 253, 600);
  }

  popup(url, height, width) {
    const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const wTop = window.screenTop ? window.screenTop : window.screenY;
    const left = wLeft + (window.innerWidth / 2) - (width / 2);
    const top = wTop + (window.innerHeight / 2) - (height / 2);

    window.open(
      url,
      '_blank',
      'location=yes,height=' + height + ',width=' + width + ',top=' + top + ',left=' + left + ',scrollbars=yes,status=no');
  }

  setEmail() {
    setTimeout(() => {
      this.email = 'subject=' + this.subject + '&body=' + this.caption + '%0A%0A' + encodeURIComponent(this.link);
    }, 300);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.$html = $('html');
    this.$body = $('body');

    this.setEmail();
  }
}
